import React, { useState } from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronDown,
    faChevronUp,
    faArrowDown,
    faToolbox,
    faFlask,
    faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

// Inventory Item Component
const InventoryItem = ({ data, type }) => {
    const { t } = useTranslation();

    const isLowStock = data.percentage <= 20;
    const isMediumStock = data.percentage > 20 && data.percentage <= 85;

    const getItemClass = () => {
        if (isLowStock) return 'inventory-item-low-stock';
        if (isMediumStock) return 'inventory-item-medium-stock';
        return 'inventory-item-high-stock';
    };

    const getTextClass = () => {
        if (isLowStock) return 'inventory-item-text-low';
        if (isMediumStock) return 'inventory-item-text-medium';
        return 'inventory-item-text-high';
    };

    const getStatusBadgeClass = () => {
        if (isLowStock) return 'inventory-status-badge-low';
        if (isMediumStock) return 'inventory-status-badge-medium';
        return 'inventory-status-badge-high';
    };

    const getStatusText = () => {
        if (isLowStock) return t('inventoryStatusLowStocks');
        return data.percentage > 85
            ? t('inventoryStatusAvailable')
            : t('inventoryStatusInStocks');
    };

    const getStatusIcon = () => {
        if (isLowStock) return faArrowDown;
        return faCheckCircle;
    };

    const textClass = getTextClass();

    return (
        // <div className={`p-3 mb-3 shadow-none card-hover inventory-item ${getItemClass()}`}>
            
        //     <div className="d-flex justify-content-between align-items-start mb-1">
        //         <div style={{ flex: 1 }}>
        //             <p className={`fw-medium mb-0 font-size-13 ${textClass}`}>
        //                 {data.name}
        //             </p>

        //             <span className={`fw-normal d-block font-size-12 ${textClass}`}>
        //                 {data.vendor}
        //             </span>
        //         </div>

        //         <Badge
        //             pill
        //             bg="transparent"
        //             className={`px-2 py-1 d-flex align-items-center fw-normal font-size-13 ${getStatusBadgeClass()}`}
        //         >
        //             <FontAwesomeIcon
        //                 icon={getStatusIcon()}
        //                 className="me-1 fs-11"
        //             />
        //             {getStatusText()}
        //         </Badge>
        //     </div>

        //     <div className="d-flex justify-content-between align-items-end">
        //         <div>
        //             <span className={`display-5 fw-bolder font-size-22 inventory-quantity-text ${textClass}`}>
        //                 {data.current}
        //             </span>
        //             <span className={`fw-light mx-1 display-6 font-size-15 ${textClass}`}>
        //                 /
        //             </span>
        //             <span className={`fw-medium font-size-12 ${textClass}`}>
        //                 {data.total} {data.unit}
        //             </span>
        //         </div>

        //         <div className="text-end">
        //             <span className={`display-5 fw-bolder font-size-22 inventory-quantity-text ${textClass}`}>
        //                 {data.percentage}%
        //             </span>

        //             <div className={`fs-11 ${textClass}`}>
        //                 {t('inventoryReadyLabel')}
        //             </div>
        //         </div>
        //     </div>
        // </div>

        <div className="text-center py-5">{t("NoDataFound")}</div>
    );
};

// Inventory Section Component
const InventorySection = ({ title, items, iconName, count }) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <Card className="border shadow-none rounded-3 overflow-hidden">
            <Card.Header
                className={`py-3 px-4 cursor-pointer inventory-section-header ${isExpanded ? 'inventory-section-header-expanded' : 'inventory-section-header-collapsed'}`}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-start">
                        <i className={`fas fa-${iconName === faToolbox ? 'toolbox' : 'flask'} text-secondary me-2 mt-1`}></i>
                        <div>
                            <h3 className="mb-0 fw-medium font-size-15">{title}</h3>
                            <p className=" d-block fw-normal mb-0 font-size-13">{count} {t('inventoryItemsLabel')}</p>
                        </div>
                    </div>

                    <FontAwesomeIcon
                        icon={isExpanded ? faChevronUp : faChevronDown}
                        className="text-muted"
                    />
                </div>
            </Card.Header>

            {isExpanded && (
                <Card.Body className="p-4">
                    {items.map((item, index) => (
                        <InventoryItem key={index} data={item} />
                    ))}
                </Card.Body>
            )}
        </Card>
    );
};

// Sample Data (RESTORED)
const toolsData = [
    {
        name: 'Industrial Vacuum Cleaner',
        vendor: 'Vendor: CleanPro Supplies',
        current: 2,
        total: 2,
        unit: 'units',
        percentage: 100
    }
];

const chemicalsData = [
    {
        name: 'Eco Floor Cleaning Solution',
        vendor: 'Vendor: GreenClean Inc.',
        current: 8,
        total: 10,
        unit: 'liters',
        percentage: 80
    }
];

// Main Inventory Component
const Inventory = () => {
    const { t } = useTranslation();

    return (
        <div>
            <Row>
                <Col lg={6} className="mb-3">
                    <InventorySection
                        title={t('inventoryToolsTitle')}
                        items={toolsData}
                        iconName={faToolbox}
                        count={0}
                    />
                </Col>

                <Col lg={6} className="mb-3">
                    <InventorySection
                        title={t('inventoryChemicalsTitle')}
                        items={chemicalsData}
                        iconName={faFlask}
                        count={0}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Inventory;